import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import SuccessIcon from 'components/icons/SuccessIcon'

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`

const DialogContent = styled.div`
  background: white;
  padding: 32px;
  border-radius: 12px;
  width: 500px;
  max-width: 90vw;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
`

const IconWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #101828;
  margin-bottom: 16px;
`

const Message = styled.div`
  color: #667085;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 24px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const SuccessDialog = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <DialogOverlay>
      <DialogContent>
        <IconWrapper>
          <SuccessIcon />
        </IconWrapper>
        <Title>Request Received</Title>
        <Message>
          May take sometime to deliver the email
          meanwhile you may continue with other tasks
        </Message>
        <ButtonWrapper>
          <Button.Primary text="Close" onClick={onClose} />
        </ButtonWrapper>
      </DialogContent>
    </DialogOverlay>
  )
}

export default SuccessDialog
